import securedAxios from '~/javascript/utils/axios'

const axios = securedAxios()

export function runSemanticAnalysis(pageId) {
  return axios.post(`/ajax/website_pages/${pageId}/run_semantic_analysis`)
}

export function getSemanticAnalysis(pageId) {
  return axios.get(`/ajax/website_pages/${pageId}/semantic_analysis`)
}

export function approveTopicPlan(pageId, topicSelections = []) {
  return axios.post(`/ajax/website_pages/${pageId}/approve_topic_plan`, { topic_selections: topicSelections })
}
